export default __webpack_public_path__ + "static/media/israel.117c3144.png";